import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Webcamp Ljubljana was a blast",
  "description": "",
  "published": "2009-11-29T00:00:00.000Z",
  "redirect_from": ["/blog/webcamp-ljubljana-was-a-blast/swizec/908"],
  "categories": "life, review, Uncategorized",
  "hero": "./img/2705-4140074023_b8f80681a7.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "http://www.flickr.com/photos/ivanbrezakbrkan/4140074023/"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "500px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "74.88789237668162%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'300\\'%20viewBox=\\'0%200%20400%20300\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20150v150h401V0h-82l-7%204-10%204-7%204a671%20671%200%2001-50%2029v2l-1%201-5%203c-7%202-7%202-3%205%206%206-3%207-18%202l-6-2%205%201c3%200%204%200%203-1s-1-1%201-1c4-2%205-5%204-8-1-5%202-8%205-6%203%203%204%204%203%205l28-14a2322%202322%200%200148-27A3131%203131%200%200099%203c4%203%204%207%200%206l-2%201-9%201c-11%200-11%200-6%205l4%205%204%203c2%200%203%200%202%201-2%201-34-6-31-7h-2l-3-1h2c2%200%202%200%201-1%200-2%201-3%205-4%204-2%205-3%204-4l-1-5V0H0v150M45%2024a2653%202653%200%2000-3%20160v22h-3a1359%201359%200%200042%201%20967101%20967101%200%2000160-6c-2-1-2-2-2-5a2458%202458%200%2000-10-136A7967%207967%200%200155%2022l-10-2v4m352%2022a1738%201738%200%2000-43%2018%204762%204762%200%200146-18h-3\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/d08ecea91d664a4da4913a5f05c3b7c5/ca0a1/2705-4140074023_b8f80681a7.webp 223w", "/static/d08ecea91d664a4da4913a5f05c3b7c5/75680/2705-4140074023_b8f80681a7.webp 445w", "/static/d08ecea91d664a4da4913a5f05c3b7c5/b0a15/2705-4140074023_b8f80681a7.webp 500w"],
                "sizes": "(max-width: 500px) 100vw, 500px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/d08ecea91d664a4da4913a5f05c3b7c5/853b2/2705-4140074023_b8f80681a7.jpg 223w", "/static/d08ecea91d664a4da4913a5f05c3b7c5/0a4fe/2705-4140074023_b8f80681a7.jpg 445w", "/static/d08ecea91d664a4da4913a5f05c3b7c5/41099/2705-4140074023_b8f80681a7.jpg 500w"],
                "sizes": "(max-width: 500px) 100vw, 500px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/d08ecea91d664a4da4913a5f05c3b7c5/41099/2705-4140074023_b8f80681a7.jpg",
                "alt": "2705 4140074023 b8f80681a7",
                "title": "Swizec at webcamp",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Swizec at webcamp`}</figcaption>{`
  `}</figure></a></p>
    <p>{`It was it truly was! Happy fun times all around.`}</p>
    <p>{`Until about like six in the afternoon or whatever the time was when everybody looked like a knackered zombie held together solely by the caffeine molecules in the blood stream. The last presenter I was paying any amount of serious attention to - Igor Kolar - even opened his talk with something to the extent of `}<em parentName="p">{`Excuse me when everything goes wrong, but I'm knackered as hell.`}</em></p>
    <p>{`But it was fun, although the insolent bastard who provided only herbal tea should be shot, quartered and hung as a pinnata and beaten with sticks by small children until tea started falling out ... meh we the tea drinkers forgive him, there was still taurin available.`}</p>
    <p>{`I put forth a presentation of the `}<a parentName="p" {...{
        "href": "http://synapticweb.org/"
      }}>{`Synaptic Web`}</a>{`, how we're getting there and what it means blahblahblah. Unlike last time I even uttered actual words this time! Victory for all involved! Well ... not completely, there was the small issue of my having been versed in doing pitches lately, which resulted in the talk being bloody too short by a country mile.`}</p>
    <p>{`Somehow we fixed that by me blabbing on for a few moments about what Preona is up to and then the whole presentation sort of devolved into a conversation of sorts and we stumbled around the interwebs for a while looking for interesting things and we even watched a video! Yay.`}</p>
    <p>{`Now that I think of it, I could've just rolled the video of Khris Loux talking about these things that can be found on `}<a parentName="p" {...{
        "href": "http://synapticweb.org/"
      }}>{`synapticweb.org`}</a>{`, some other time perhaps.`}</p>
    <p>{`Meh it wasn't all that bad, we ended up being thrown out and even if the public was less than amused, standing there in front of them and making a fool of myself was damn fun.`}</p>
    <p>{`What else ... (the phrased used often during my presentation) ... oh right! We can talk for a bit about the wonderful food that was served. It was wonderful! Omnom!`}</p>
    <p>{`And uhm ... well I guess 90% of the people reading this were at webcamp ljubljana anyway so I'll just shut up now, here's the slides for my presentation.`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.slideshare.net/Swizec/synapticweb-webcamp-2k9",
        "title": "Synapticweb Webcamp 2k9"
      }}>{`Synapticweb Webcamp 2k9`}</a></p>
    <p>{`View more `}<a parentName="p" {...{
        "href": "http://www.slideshare.net/"
      }}>{`presentations`}</a>{` from `}<a parentName="p" {...{
        "href": "http://www.slideshare.net/Swizec"
      }}>{`Swizec`}</a>{`.`}</p>
    <p>{`PS: the second slide contains a video that slideshare doesn't seem to handle too well`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      